import BoostLogo from "@/assets/svg/full-logo/boost-white.svg";
import PayLogo from "@/assets/svg/full-logo/pay-white.svg";
import ShieldLogo from "@/assets/svg/full-logo/shield-white.svg";
import TaskLogo from "@/assets/svg/full-logo/task.svg";
import Button from "@/components/ui/button";
import {
  EnfinityPrimaryBtn,
  EnfinitySecondaryBtn,
} from "@/components/design-system/enfinity/EnfinityButton";
import scrollTo from "@/utils/scrollTo";
import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

export default function EnfiniNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const landingPage = import.meta.env.VITE_LANDING_PAGE;
  const isEnfiniShield = landingPage === "shield" || location.pathname.includes("enfinishield");

  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);

  let logo;
  switch (landingPage) {
    case "shield":
      logo = ShieldLogo;
      break;
    case "pay":
      logo = PayLogo;
      break;
    case "boost":
      logo = BoostLogo;
      break;
    case "task":
      logo = TaskLogo;
      break;
    default:
      logo = ShieldLogo;
      break;
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      setLastScrollY(window.scrollY);

      setIsAtTop(window.scrollY === 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleScrollTo = (targetPath, scrollId) => {
    if (location.pathname === targetPath) {
      scrollTo(scrollId);
    } else {
      navigate(targetPath, { state: { scrollTo: scrollId } });
    }
  };

  const goUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      <div
            className={`${
          !isAtTop || isMobileMenuOpen
            ? landingPage === "pay" || landingPage === "boost" || landingPage === "shield"
              ? "bg-[#1a1a1a]"
              : "bg-[linear-gradient(to_right,var(--primary),var(--tertiary))]"
            : "bg-transparent"
        } fixed top-0 left-0 right-0 transition-transform duration-300 z-50 ${
          showNavbar ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="5xl:max-w-[100rem] 5xl:mx-auto relative z-[60]">
          <div className={`py-4 px-6 lg:px-16 4xl:px-[320px] flex ${landingPage === "pay" ? "justify-between" : "justify-between"} items-center relative`}>
            <Link to="/">
              <img src={logo} className="w-24 lg:w-32" alt="Enfinity Logo" />
            </Link>

            {/* Desktop Links */}
            {landingPage === "pay" ? (
              <div className="hidden lg:flex gap-8 text-white absolute left-1/2 -translate-x-1/2">
                {location.pathname === "/" ? (
                  <p
                    className="cursor-pointer hover:underline"
                    onClick={() => handleScrollTo("/", "header")}
                  >
                    Home
                  </p>
                ) : (
                  <Link to="/" className="block">
                    <p 
                      className="cursor-pointer hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/", { state: { scrollTo: "header" } });
                      }}
                    >
                      Home
                    </p>
                  </Link>
                )}
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => handleScrollTo("/", "our-features")}
                >
                  Our Offers
                </p>
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => handleScrollTo("/", "how-it-works")}
                >
                  How it Works
                </p>
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => handleScrollTo("/", "faqs")}
                >
                  FAQs
                </p>
              </div>
            ) : landingPage === "boost" ? (
              <div className="hidden lg:flex gap-10 text-white absolute left-1/2 -translate-x-1/2">
                {location.pathname === "/" ? (
                  <p
                    className="cursor-pointer hover:underline"
                    onClick={() => handleScrollTo("/", "header")}
                  >
                    Home
                  </p>
                ) : (
                  <Link to="/" className="block">
                    <p 
                      className="cursor-pointer hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/", { state: { scrollTo: "header" } });
                      }}
                    >
                      Home
                    </p>
                  </Link>
                )}
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => {
                    if (location.pathname === "/" || location.pathname === "/our-solutions/enfiniboost") {
                      scrollTo("earning-boost");
                    } else {
                      navigate("/our-solutions/enfiniboost", { state: { scrollTo: "earning-boost" } });
                    }
                  }}
                >
                  Revenue Calculator
                </p>
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => {
                    if (location.pathname === "/" || location.pathname === "/our-solutions/enfiniboost") {
                      scrollTo("how-it-works");
                    } else {
                      navigate("/our-solutions/enfiniboost", { state: { scrollTo: "how-it-works" } });
                    }
                  }}
                >
                  How it Works
                </p>
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => handleScrollTo("/", "faqs")}
                >
                  FAQs
                </p>
              </div>
            ) : landingPage === "shield" ? (
              <div className="hidden lg:flex gap-10 text-white absolute left-1/2 -translate-x-1/2">
                {location.pathname === "/" ? (
                  <p
                    className="cursor-pointer hover:underline"
                    onClick={() => handleScrollTo("/", "header")}
                  >
                    Home
                  </p>
                ) : (
                  <Link to="/" className="block">
                    <p 
                      className="cursor-pointer hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/", { state: { scrollTo: "header" } });
                      }}
                    >
                      Home
                    </p>
                  </Link>
                )}
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => {
                    if (location.pathname === "/" || location.pathname === "/our-solutions/enfinishield") {
                      scrollTo("how-much-shield");
                    } else {
                      navigate("/our-solutions/enfinishield", { state: { scrollTo: "how-much-shield" } });
                    }
                  }}
                >
                  Revenue Calculator
                </p>
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => {
                    if (location.pathname === "/" || location.pathname === "/our-solutions/enfinishield") {
                      scrollTo("how-it-works");
                    } else {
                      navigate("/our-solutions/enfinishield", { state: { scrollTo: "how-it-works" } });
                    }
                  }}
                >
                  How it Works
                </p>
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => handleScrollTo("/", "faqs")}
                >
                  FAQs
                </p>
              </div>
            ) : (
              <div className="hidden lg:flex gap-8 text-white">
                {location.pathname === "/" ? (
                  <p
                    className="cursor-pointer hover:underline"
                    onClick={() => goUp()}
                  >
                    Home
                  </p>
                ) : (
                  <Link to="/" className="block">
                    <p className="cursor-pointer hover:underline">Home</p>
                  </Link>
                )}
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => handleScrollTo("/", "features")}
                >
                  Features
                </p>
                <p
                  className="cursor-pointer hover:underline"
                  onClick={() => handleScrollTo("/", "how-it-works")}
                >
                  How it works
                </p>
                {landingPage === "boost" && (
                  <p
                    className="cursor-pointer hover:underline"
                    onClick={() => handleScrollTo("/", "partners")}
                  >
                    Partners
                  </p>
                )}
                {location.pathname === "/contact-us" ? (
                  <p
                    className="cursor-pointer hover:underline"
                    onClick={() => goUp()}
                  >
                    Contact Us
                  </p>
                ) : (
                  <Link to="/contact-us" className="block">
                    <p className="cursor-pointer hover:underline">Contact Us</p>
                  </Link>
                )}
              </div>
            )}

            {/* Desktop Buttons */}
            <div className="hidden lg:flex items-center gap-2.5">
              {landingPage === "pay" || landingPage === "boost" || landingPage === "shield" ? (
                <>
                  <a
                    href="https://core.enfinity.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <EnfinitySecondaryBtn
                      name="Login"
                      className="!min-w-0 px-10"
                    />
                  </a>
                  <a
                    href="https://core.enfinity.com/signup"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <EnfinityPrimaryBtn
                      name={isEnfiniShield ? "Get protected now" : "Start today for free"}
                      className="!min-w-0 px-10"
                    />
                  </a>
                </>
              ) : (
                <>
                  <Button
                    asChild
                    className="shadow bg-transparent border border-white text-white w-28 py-5 rounded-full"
                  >
                    <a
                      href="https://core.enfinity.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Login
                    </a>
                  </Button>
                  <Link to="/esign">
                    <Button className="rounded-full shadow bg-white text-black w-28 py-5">
                      Sign up
                    </Button>
                  </Link>
                </>
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="lg:hidden text-white"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className={`lg:hidden h-screen ${landingPage === "pay" || landingPage === "boost" || landingPage === "shield" ? "bg-[#1a1a1a]" : "bg-[linear-gradient(45deg,var(--primary),var(--tertiary))]"} text-white flex flex-col gap-6 px-6 4xl:px-[320px] py-8`}>
              {landingPage === "pay" ? (
                <>
                  {location.pathname === "/" ? (
                    <p
                      onClick={() => {
                        scrollTo("header");
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      Home
                    </p>
                  ) : (
                    <Link 
                      to="/" 
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/", { state: { scrollTo: "header" } });
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      Home
                    </Link>
                  )}
                  <p
                    onClick={() => {
                      scrollTo("our-features");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Our Offers
                  </p>
                  <p
                    onClick={() => {
                      scrollTo("how-it-works");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    How it Works
                  </p>
                  <p
                    onClick={() => {
                      scrollTo("faqs");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    FAQs
                  </p>
                </>
              ) : landingPage === "boost" ? (
                <>
                  {location.pathname === "/" ? (
                    <p
                      onClick={() => {
                        scrollTo("header");
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      Home
                    </p>
                  ) : (
                    <Link 
                      to="/" 
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/", { state: { scrollTo: "header" } });
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      Home
                    </Link>
                  )}
                  <p
                    onClick={() => {
                      if (location.pathname === "/" || location.pathname === "/our-solutions/enfiniboost") {
                        scrollTo("earning-boost");
                      } else {
                        navigate("/our-solutions/enfiniboost", { state: { scrollTo: "earning-boost" } });
                      }
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Revenue Calculator
                  </p>
                  <p
                    onClick={() => {
                      if (location.pathname === "/" || location.pathname === "/our-solutions/enfiniboost") {
                        scrollTo("how-it-works");
                      } else {
                        navigate("/our-solutions/enfiniboost", { state: { scrollTo: "how-it-works" } });
                      }
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    How it Works
                  </p>
                  <p
                    onClick={() => {
                      scrollTo("faqs");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    FAQs
                  </p>
                </>
              ) : landingPage === "shield" ? (
                <>
                  {location.pathname === "/" ? (
                    <p
                      onClick={() => {
                        scrollTo("header");
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      Home
                    </p>
                  ) : (
                    <Link 
                      to="/" 
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/", { state: { scrollTo: "header" } });
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      Home
                    </Link>
                  )}
                  <p
                    onClick={() => {
                      if (location.pathname === "/" || location.pathname === "/our-solutions/enfinishield") {
                        scrollTo("how-much-shield");
                      } else {
                        navigate("/our-solutions/enfinishield", { state: { scrollTo: "how-much-shield" } });
                      }
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Revenue Calculator
                  </p>
                  <p
                    onClick={() => {
                      if (location.pathname === "/" || location.pathname === "/our-solutions/enfinishield") {
                        scrollTo("how-it-works");
                      } else {
                        navigate("/our-solutions/enfinishield", { state: { scrollTo: "how-it-works" } });
                      }
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    How it Works
                  </p>
                  <p
                    onClick={() => {
                      scrollTo("faqs");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    FAQs
                  </p>
                </>
              ) : (
                <>
                  <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
                    Home
                  </Link>
                  <p
                    onClick={() => {
                      scrollTo("features");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Features
                  </p>
                  <p
                    onClick={() => {
                      scrollTo("how-it-works");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    How it works
                  </p>
                  {landingPage === "boost" && (
                    <p
                      onClick={() => {
                        scrollTo("partners");
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      Partners
                    </p>
                  )}
                  <Link to="/contact-us" className="block">
                    <p className="cursor-pointer hover:underline">Contact Us</p>
                  </Link>
                </>
              )}

              <div className="flex flex-col gap-2.5 mt-2">
                {landingPage === "pay" || landingPage === "boost" || landingPage === "shield" ? (
                  <>
                    <a
                      href="https://core.enfinity.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex w-full items-center justify-center"
                    >
                      <EnfinitySecondaryBtn
                        name="Login"
                        className="w-full !min-w-0"
                      />
                    </a>
                    <a
                      href="https://core.enfinity.com/signup"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex w-full items-center justify-center"
                    >
                      <EnfinityPrimaryBtn
                        name={isEnfiniShield ? "Get protected now" : "Start today for free"}
                        className="w-full !min-w-0"
                      />
                    </a>
                  </>
                ) : (
                  <>
                    <Button
                      asChild
                      className="rounded-full shadow bg-transparent border border-white text-white w-full py-5"
                    >
                      <a
                        href="https://core.enfinity.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Login
                      </a>
                    </Button>
                    <Link to="/esign">
                      <Button className="rounded-full shadow bg-white text-black w-full py-5">
                        Sign up
                      </Button>
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <Outlet />
    </div>
  );
}
